import RejectedChart from './RejectedChart.container';

export default RejectedChart;
